class SubscriptionAccordion extends HTMLElement {
  constructor() {
    super();

    this.allRadioButtons = document.querySelectorAll('.c-sub-radio-buttons');
    this.allAccordions = document.querySelectorAll('subscription-accordion');

    this.radioButtons = this.querySelector('.c-sub-radio-buttons');

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    if (this.radioButtons) {
      this.addEventListener('click', this.handleClick);
    }
  }

  disconnectedCallback() {
    if (this.radioButtons) {
      this.removeEventListener('click', this.handleClick);
    }
  }

  handleClick() {
    this.allAccordions.forEach(accordion => {
      accordion.removeAttribute('data-info');
    });

    this.setAttribute('data-info', 'active');

    this.allRadioButtons.forEach(radioButton => {
      radioButton.classList.remove('radio-buttons-visible');
    });

    this.radioButtons.classList.add('radio-buttons-visible');
  }
}

customElements.define('subscription-accordion', SubscriptionAccordion);

// Subscription form: option steps, price/image updates and add to cart.
// Reads `productList`, which sections/sub-subscription.liquid renders from the section's collections.
function initSubscriptionForm() {
  if (!document.querySelector('.js-select-flavour') || typeof productList === 'undefined') return;

  const chooseFlavourSelect = document.querySelector('.js-select-flavour');
  const choosePackageSelect = document.querySelector('.js-select-package');
  const chooseDeliverSelect = document.querySelector('.js-select-deliver');
  const addToCartButton = document.querySelector('.js-add-to-cart-button');
  const radioInputs = document.querySelectorAll('.c-sub-products__radio');
  const formError = document.querySelector('.js-sub-form-error');
  const formWrapper = document.getElementById('subscription-sub-form');
  let currentVariantId = formWrapper.dataset.initialVariantId;
  let currentSellingPlanId = formWrapper.dataset.initialSellingPlanId;


  // What the customer has explicitly picked in each step. The product step always has a value (first one is pre-checked).
  const selections = { flavour: null, size: null, delivery: null };

  const findProductById = (productId) => {
    for (const collection of productList) {
      for (const product of collection.products) {
        if (product.id === productId) return product;
      }
    }
    return null;
  };

  const findVariantById = (variantId) => {
    for (const collection of productList) {
      for (const product of collection.products) {
        for (const variant of product.variants) {
          if (variant.id === variantId) return variant;
        }
      }
    }
    return null;
  };

  const getStep = (step) => document.querySelector(`subscription-accordion[data-step="${step}"]`);

  function setSelectedLabel(step, text) {
    const label = document.querySelector(`.js-selected-${step}`);
    if (label) label.textContent = text || '';
  }

  function markSelectedOption(select) {
    Array.from(select.options).forEach(option => option.classList.remove('option-selected'));
    if (select.selectedIndex > -1) select.options[select.selectedIndex].classList.add('option-selected');
  }

  function isSizeStepNeeded() {
    return !document.querySelector('.js-hide-package').classList.contains('hidden');
  }

  function getMissingSteps() {
    const missing = [];
    if (!selections.flavour) missing.push('flavour');
    if (isSizeStepNeeded() && !selections.size) missing.push('size');
    if (!selections.delivery) missing.push('delivery');
    return missing;
  }

  function updateFormState() {
    ['flavour', 'size', 'delivery'].forEach(step => {
      if (selections[step]) getStep(step)?.classList.remove('is-required');
    });
    addToCartButton?.classList.toggle('is-incomplete', getMissingSteps().length > 0);
  }

  // Price for the chosen delivery frequency, falling back to the variant's first plan
  function getAllocation(variant) {
    return variant.selling_plan_allocations.find(allocation => allocation.selling_plan_id === selections.delivery)
      || variant.selling_plan_allocations[0];
  }

  function updatePriceForVariant(variant) {
    const allocation = getAllocation(variant);
    if (!allocation) return;
    const newPrice = (allocation.price / 100).toFixed(2);
    const newComparePrice = (allocation.compare_at_price / 100).toFixed(2);
    updatePriceWithCurrency(newPrice, newComparePrice, Shopify.currency.active == 'CAD' ? 'CAD' : '');
  }

  // Function to update the Product select options
  function updateFlavorOptions(collectionId) {
    const selectedCollection = productList.find(collection => collection.id === collectionId);
    if (selectedCollection) {
      const flavourCount = selectedCollection.products.length;
      chooseFlavourSelect.setAttribute('size', flavourCount);
      selectedCollection.products.forEach((product) => {
        const option = document.createElement('option');
        option.value = product.id;
        option.textContent = product.title;
        chooseFlavourSelect.appendChild(option);
      });
      chooseFlavourSelect.selectedIndex = -1;
      document.querySelector('.js-hide-flavour').classList.toggle('is-remove-arrow', flavourCount === 1);
    }
  }

  // Until a flavour is picked there are no sizes to show, so keep the step visible with a hint instead of hiding it
  function resetSizeStep() {
    const sizeSelect = document.getElementById('choose_size');
    sizeSelect.innerHTML = '';
    sizeSelect.classList.add('is-empty');
    document.querySelector('.js-size-hint')?.classList.remove('hidden');
    document.querySelector('.js-hide-package').classList.remove('hidden');
    selections.size = null;
    setSelectedLabel('size', '');
  }

  // Function to update the size select options
  function updateSizeOptions(productId) {
    const product = findProductById(productId);
    const sizeSelect = document.getElementById('choose_size');
    const hasOnlyDefaultVariant = product.variants.length === 1 && product.variants[0].title == 'Default Title';

    sizeSelect.innerHTML = '';
    sizeSelect.setAttribute('size', product.variants.length);
    product.variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title;
      sizeSelect.appendChild(option);
    });
    sizeSelect.selectedIndex = -1;
    sizeSelect.classList.remove('is-empty');
    document.querySelector('.js-size-hint')?.classList.add('hidden');
    document.querySelector('.js-hide-package').classList.toggle('hidden', hasOnlyDefaultVariant);

    // A product with a single size has nothing to choose, so that step counts as done
    selections.size = hasOnlyDefaultVariant ? product.variants[0].id : null;
    setSelectedLabel('size', '');
  }

  // function to update the delivery select options, keeping the chosen frequency when the new variant offers it
  function updateDeliveryOptions(variantId) {
    const foundVariant = findVariantById(variantId);
    const deliverySelect = document.getElementById('deliver_every');
    deliverySelect.innerHTML = '';
    deliverySelect.setAttribute('size', foundVariant.selling_plan_allocations.length);
    foundVariant.selling_plan_allocations.forEach((delivery) => {
      const option = document.createElement('option');
      option.value = delivery.selling_plan_id;
      option.textContent = formWrapper.dataset.deliveryOptionTemplate.replace('__plan_name__', delivery.name);
      deliverySelect.appendChild(option);
    });

    const keptAllocation = foundVariant.selling_plan_allocations.find(delivery => delivery.selling_plan_id === selections.delivery);
    if (keptAllocation) {
      deliverySelect.value = keptAllocation.selling_plan_id;
      markSelectedOption(deliverySelect);
    } else {
      deliverySelect.selectedIndex = -1;
      selections.delivery = null;
      setSelectedLabel('delivery', '');
    }
    currentSellingPlanId = getAllocation(foundVariant).selling_plan_id;
  }

  chooseFlavourSelect.addEventListener('change', (event) => {
    markSelectedOption(chooseFlavourSelect);
    const selectedProduct = findProductById(event.target.value);
    if (selectedProduct) {
      const firstSelectedVariant = selectedProduct.variants[0];

      selections.flavour = selectedProduct.id;
      setSelectedLabel('flavour', selectedProduct.title);
      updateSizeOptions(selectedProduct.id);
      updateDeliveryOptions(firstSelectedVariant.id);
      updatePriceForVariant(firstSelectedVariant);
      updateProductImage(firstSelectedVariant.image || selectedProduct.image);
      currentVariantId = firstSelectedVariant.id;
      updateFormState();
    }
  });

  if(choosePackageSelect){
    choosePackageSelect.addEventListener('change', (event) => {
      markSelectedOption(choosePackageSelect);
      const selectedVariantId = event.target.value;
      const foundVariant = findVariantById(selectedVariantId);

      selections.size = selectedVariantId;
      setSelectedLabel('size', foundVariant.title);
      updateDeliveryOptions(selectedVariantId);
      updatePriceForVariant(foundVariant);
      if (foundVariant.image) updateProductImage(foundVariant.image);
      currentVariantId = selectedVariantId;
      updateFormState();
    });
  }

  if(chooseDeliverSelect){
    chooseDeliverSelect.addEventListener('change', (event) => {
      markSelectedOption(chooseDeliverSelect);
      const selectedSellingPlanId = event.target.value;
      const currentVariant = findVariantById(String(currentVariantId));
      const allocation = currentVariant?.selling_plan_allocations.find(delivery => delivery.selling_plan_id === selectedSellingPlanId);

      selections.delivery = selectedSellingPlanId;
      setSelectedLabel('delivery', allocation ? allocation.name : '');
      addToCartButton.dataset.currentSellingPlanId = selectedSellingPlanId;
      currentSellingPlanId = selectedSellingPlanId;
      if (currentVariant) updatePriceForVariant(currentVariant);
      updateFormState();
    });
  }

  function updatePriceWithCurrency(newPrice, newComparePrice, currency) {
    // Find the price display element by its class name
    const priceDisplay = document.querySelector('.js-sub-form-price');
    const buttonPrice = document.querySelector('.js-button-price');
    // Check if the element exists
    if (priceDisplay) {
      // Update the inner HTML with the new price, compare price, and currency
      priceDisplay.innerHTML = `<span class="money">$ ${newPrice} ${currency}</span><s><span class="money">$ ${newComparePrice}</span></s>`;
    }
    if(buttonPrice){
      buttonPrice.innerHTML = `- $ ${newPrice} ${currency}`;
    }
  }

  // Preload off-screen instead of waiting on the <img>: it is lazy-loaded and display:none on desktop, so its load event never fired
  function updateProductImage(newImage) {
    if (!newImage) return;
    const productImage = document.querySelector('.js-product-img');
    const productBg = document.querySelector('.js-product-bg');
    const spinner = document.querySelector('.js-loading-spinner');
    const hideSpinner = () => {
      if (spinner) spinner.style.display = 'none';
    };

    if (spinner) spinner.style.display = 'flex';

    const preloader = new Image();
    preloader.onload = () => {
      if (productImage) productImage.src = newImage;
      if (productBg) productBg.style.backgroundImage = `url(${newImage})`;
      hideSpinner();
    };
    preloader.onerror = hideSpinner;
    preloader.src = newImage;
  }

  // Add a change event listener to each radio input
  radioInputs.forEach(input => {
    input.addEventListener('change', (event) => {
      if (event.target.checked && event.target.value) {
        chooseFlavourSelect.innerHTML = '';
        updateFlavorOptions(event.target.value);
        selections.flavour = null;
        setSelectedLabel('flavour', '');
        setSelectedLabel('product', event.target.labels[0]?.textContent.trim());
        resetSizeStep();
        updateDeliveryOptions(event.target.dataset.firstvariant);
        const firstVariant = findVariantById(event.target.dataset.firstvariant);
        if (firstVariant) updatePriceForVariant(firstVariant);
        updateProductImage(event.target.dataset.featuredimage);
        currentVariantId = event.target.dataset.firstvariant;
        updateFormState();
      }
    });
  });

  function showRequiredSteps(missing) {
    missing.forEach(step => getStep(step)?.classList.add('is-required'));
    const firstMissing = getStep(missing[0]);
    if (firstMissing) {
      firstMissing.handleClick?.();
      firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function showFormError(message) {
    if (!formError) return;
    formError.textContent = message || '';
    formError.classList.toggle('hidden', !message);
  }

  function resetAddToCartButton() {
    addToCartButton.classList.remove('loading');
    addToCartButton.removeAttribute('aria-disabled');
    addToCartButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }

  let quantityInput = document.querySelector('.js-quanity-input');
  if(addToCartButton){
    updateFormState();

    addToCartButton.addEventListener('click', (event) => {
      event.preventDefault();
      if (addToCartButton.classList.contains('loading')) return;

      const missing = getMissingSteps();
      if (missing.length) {
        showRequiredSteps(missing);
        return;
      }
      showFormError('');

      const formData = {
        'items': [{
          'id': currentVariantId,
          'quantity': quantityInput.value || 1,
          'selling_plan': currentSellingPlanId,
        }]
      };

      // Ask for the drawer's sections in the same request so the side cart can re-render with the new line
      const cartDrawer = document.querySelector('cart-drawer');
      const canRenderDrawer = cartDrawer && typeof cartDrawer.renderContents === 'function';
      if (canRenderDrawer) {
        formData.sections = cartDrawer.getSectionsToRender().map((section) => section.id).join(',');
        formData.sections_url = window.location.pathname;
        cartDrawer.setActiveElement(document.getElementById('cart-icon-bubble'));
      }

      addToCartButton.setAttribute('aria-disabled', true);
      addToCartButton.classList.add('loading');
      addToCartButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (!ok || data.status) {
          showFormError(data.description || data.message || formWrapper.dataset.addError);
          return;
        }
        if (canRenderDrawer) {
          cartDrawer.renderContents(data);
        } else {
          window.location = window.routes?.cart_url || '/cart';
        }
      })
      .catch(error => {
        console.error('Error:', error);
        showFormError(formWrapper.dataset.genericError);
      })
      .finally(resetAddToCartButton);
    });
  }
}

initSubscriptionForm();
